import { render, staticRenderFns } from "./EscritorioAdministracao.vue?vue&type=template&id=c9fa9d08&scoped=true"
import script from "./EscritorioAdministracao.vue?vue&type=script&lang=js"
export * from "./EscritorioAdministracao.vue?vue&type=script&lang=js"
import style0 from "./EscritorioAdministracao.vue?vue&type=style&index=0&id=c9fa9d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fa9d08",
  null
  
)

export default component.exports